module.exports = __webpack_public_path__ + "img/pegi-12-rating.da43ec9e.png";